import React, { FC } from 'react';
import { BackButton } from '../Components';

import Typography from '@mui/material/Typography';
import { Table, TableBody, TableCell, TableHead, TableRow, Stack, Box, Link } from '@mui/material';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import LoadingSpinner from '../LoadingSpinner';
import { GET_PARAGRAPH } from './paragraphs.graphql';
import { StyledPaper } from '../theme';
import { GetParagraphQuery, GuideStatus } from '../__generated__/graphql';
import { ColWidths, TableCellHead, TableCellIcon, TableCellEllipsis } from '../components/TableComponents';
import { formatDateOnly } from '../Formatters';
import { StatusChip, TagsCell } from '../guides/GuideStatusCells';
import { Link as RouterLink } from 'react-router-dom';

type Paragraph = NonNullable<NonNullable<GetParagraphQuery['paragraph']>>;

export function Details() {
  const { id } = useParams();
  const { data, loading } = useQuery(GET_PARAGRAPH, { variables: { id } });
  const paragraph = data?.paragraph;

  if (loading || !data) return <LoadingSpinner />;
  if (!paragraph) return <Typography variant="h5">Fant ikke paragraf</Typography>;

  return (
    <Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        <BackButton />
        <Typography variant="h5">
          {paragraph.number} {paragraph.title}
        </Typography>
      </Stack>

      <StyledPaper>
        <Box display="grid" gridTemplateColumns="max-content 1fr" columnGap={2}>
          <Typography>Forskrift:</Typography>
          <Typography>{paragraph.regulation}</Typography>
          <Typography variant="subtitle1">Dibk:</Typography>
          <Link href={paragraph.link ?? ''} target="blank">
            Gå til forskrift
          </Link>
        </Box>
      </StyledPaper>
      <Guides guides={paragraph.guides ?? []} />
    </Stack>
  );
}

type GuideModel = NonNullable<Paragraph['guides']>[0];
const Guides: FC<{ guides: GuideModel[] }> = ({ guides }) => {
  return (
    <StyledPaper>
      <Typography variant="h5" gutterBottom>
        Anvisninger
      </Typography>
      <Table size="small">
        <ColWidths widths={[40, 120, null, 250, 40, 140]} />
        <TableHead>
          <TableRow>
            <TableCellHead>Status</TableCellHead>
            <TableCellHead>Nummer</TableCellHead>
            <TableCellHead>Tittel</TableCellHead>
            <TableCellHead>Fagområde</TableCellHead>
            <TableCellHead>Sist publisert</TableCellHead>
            <TableCellHead>Tagger</TableCellHead>
          </TableRow>
        </TableHead>
        <TableBody>
          {guides.map((x) => {
            if (!x) return null;
            const categoryTitle = x.mainCategory ? x.mainCategory.title : undefined;
            return (
              <TableRow key={x.id}>
                <TableCellIcon>
                  <StatusChip guide={x} />
                </TableCellIcon>
                <TableCell>
                  <Link component={RouterLink} to={`/guide/${x.id}`} underline="hover">
                    {x.docName}
                  </Link>
                </TableCell>
                <TableCellEllipsis title={x.docTitle != null ? x.docTitle : undefined}>{x.docTitle}</TableCellEllipsis>
                <TableCellEllipsis title={categoryTitle != null ? categoryTitle : undefined}>{categoryTitle ?? null}</TableCellEllipsis>
                <TableCell>{formatDateOnly(x.lastPublishedAt)}</TableCell>
                <TableCell>
                  <TagsCell guide={x} />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </StyledPaper>
  );
};
